/**
 * Class description
 *
 * Created: 2017-09-25
 * @author jonas
 */

import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {TimelineLite} from "gsap";
import {TeslaSymbols} from "../../config/TeslaSymbols";
import {TeslaParsedGameData} from "../server/data/TeslaParsedGameData";
import {Tesla} from "../Tesla";
import {ReelHelper} from "../utils/ReelHelper";

export class TeslaFreespinWinPresentation extends WinPresentationController {
    private _wildSymbolPositions:[number, number][];
    private _bonusSymbolPositions:[number, number][];
    private _wildsCollected:number[];
    private _hasWin:boolean;
    private _timeLine:TimelineLite | null;
    private _bonusSymbolTriggered:boolean;
    private _wildSymbols:any[];
    private _overlayWilds:boolean[][] | undefined;
    private _overlayWildsBeforeSpinStop:boolean[][];

    constructor(indexes:[number, number]) {
        super(indexes, {name : "TeslaFreespinWinPresentation", skippable : true});

        this._wildSymbols = [];
    }

    protected parseFeatureGameData(data:TeslaParsedGameData):void {
        this._wildSymbolPositions = ReelHelper.findSymbolsInReelSet(data.reels, TeslaSymbols.W);
        this._bonusSymbolPositions = ReelHelper.findSymbolsInReelSet(data.reels, TeslaSymbols.B2);
        this._wildsCollected = data.wildsCollected;
        this._bonusSymbolTriggered = data.bonusSymbolTriggered;
        let isFreespin = data.mode == GameMode.FREESPIN;
        this._overlayWilds = data.overlayWilds;
        this._overlayWildsBeforeSpinStop = data.overlayWildsBeforeSpinStop;

        this._hasWin = isFreespin;
    }

    protected hasWin():boolean {
        return this._hasWin;
    }

    protected startWinPresentation():void {

        const tl:TimelineLite = new TimelineLite();

        let overlayWildAndPoints = this.getOverlayWildAndPoints();
        let overlayWildPoints = overlayWildAndPoints.overlayWildPoints;
        let overlayWildSymbols = overlayWildAndPoints.overlayWildSymbols;

        let wildIndicatorTimeline:TimelineLite[] = Tesla.wildCollectIndicator.getWinAnimation(this._wildsCollected);
        let releaseIndicatorTimeline:TimelineLite[] = Tesla.wildCollectRelease.getWinAnimation(overlayWildPoints, overlayWildSymbols);


        if(wildIndicatorTimeline.length > 0 && releaseIndicatorTimeline.length > 0) {
            for(let i:number = 0; i < wildIndicatorTimeline.length; i++) {

                tl.add([
                    wildIndicatorTimeline[i],
                    releaseIndicatorTimeline[i]
                ]);
            }
        }

        tl.add(() => this.finish());
        this._timeLine = tl;

    }

    private getOverlayWildsAfterSpinStop() {

        const overlayWilds = this._overlayWilds!;
        const overlayWildsBeforeSpinStop = this._overlayWildsBeforeSpinStop;

        const overlayWildsAfterSpinStop = [];

        for(let i = 0; i < overlayWilds.length; i++) {
            let overlayReel = [];
            for(let j = 0; j < overlayWilds[i].length; j++) {
                let overlayWild;
                if(overlayWilds[i][j] === overlayWildsBeforeSpinStop[i][j]) {
                    overlayWild = false;
                } else {
                    overlayWild = overlayWilds[i][j];
                }
                overlayReel.push(overlayWild);
            }

            overlayWildsAfterSpinStop.push(overlayReel);

        }

        return overlayWildsAfterSpinStop;
    }

    private getOverlayWildAndPoints() {

        const overlayWilds = this.getOverlayWildsAfterSpinStop();
        const overlayWildPoints = [];
        const overlayWildSymbols = [];


        if(overlayWilds) {
            for(let i:number = 0; i < overlayWilds.length; i++) {

                let reelPoints = [];
                let reelSymbols = [];

                for(let j:number = 0; j < overlayWilds[i].length; j++) {
                    if(overlayWilds[i][j]) {
                        const symbol = Reels.getSymbol(i, j);
                        if(symbol) {
                            const basePosition:number[] = Helper.getSymbolPositions(i, j);
                            const points:PIXI.Point = new PIXI.Point(basePosition[0], basePosition[1]);

                            reelPoints.push(points);
                            reelSymbols.push(symbol)
                        }

                    }
                }

                overlayWildPoints.push(reelPoints);
                overlayWildSymbols.push(reelSymbols);
            }
        }

        return {
            overlayWildPoints : overlayWildPoints,
            overlayWildSymbols : overlayWildSymbols
        };

    }

    protected stopWinPresentation(isAborted:boolean):void {
        //Stuff that happens after complete dispatch
        if(this._timeLine) {
            if(this._timeLine.isActive()) {
                this._timeLine.pause();
                this._timeLine.kill();
            }
            this._timeLine = null;
        }
        this._wildSymbolPositions = [];
        this._bonusSymbolPositions = [];

    }

}